import lessRequire from '../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import classname from 'classname';

lessRequire('modules/shared/pagination/arrow-control.less');

const ArrowControl = ({
	paginatedComponentName,
	paginationActions,
	nextPage,
	prevPage,
	isCanNotMoveToNext,
	isCanNotMoveToPrev,
	onActionCallback
}) => (
	<div className="pagination-arrow-control">
		<span
			className={classname({prev: true, 'not-active': isCanNotMoveToPrev})}
			onClick={() => {
				!isCanNotMoveToPrev && paginationActions.prev(paginatedComponentName, prevPage);
				onActionCallback && onActionCallback();
			}} />

		<span
			className={classname({next: true, 'not-active': isCanNotMoveToNext})}
			onClick={() => {
				!isCanNotMoveToNext && paginationActions.next(paginatedComponentName, nextPage);
				onActionCallback && onActionCallback();
			}}/>
	</div>
);

ArrowControl.propTypes = {
	paginatedComponentName: PropTypes.string,
	paginationActions: PropTypes.object,
	nextPage: PropTypes.number,
	prevPage: PropTypes.number,
	isCanNotMoveToNext: PropTypes.bool,
	isCanNotMoveToPrev: PropTypes.bool,
	onActionCallback: PropTypes.func
};

export default  ArrowControl;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/pagination/arrows-control.js